/* RESPONSIBLE TEAM: team-ai-agent-2 */
import { EntityType } from 'embercom/models/data/entity-types';
import { RenderableType } from 'embercom/models/data/inbox/renderable-types';

export interface ImpersonatingAsUserWireFormat {
  renderable_type: RenderableType;
  user_id: string;
  user_display_name: string;
}

export default class ImpersonatingAsUser {
  readonly renderableType: RenderableType = RenderableType.ImpersonatingAsUser;
  readonly userId: string;
  readonly userDisplayName: string;

  constructor(userId: string, userDisplayName: string) {
    this.userId = userId;
    this.userDisplayName = userDisplayName;
  }

  get creatingEntity() {
    return { type: EntityType.Bot, id: -1 };
  }

  static deserialize(wireFormat: ImpersonatingAsUserWireFormat): ImpersonatingAsUser {
    return new ImpersonatingAsUser(wireFormat.user_id, wireFormat.user_display_name);
  }
}
